import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Popconfirm, notification, message, Tooltip } from "antd";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import ExcelJS from 'exceljs';
import ShelfLifeData from "../../common/Models/CoolingProcess/ShelfLifeData";
import ShelfLifeAnalysis from "../../common/Models/ShelfLife/ShelfLife";
import { FaChartBar } from "react-icons/fa";
import { IoMdEye } from "react-icons/io";
import {
  Row,
  Form,
  Input,
  Col,
  Select,
  Collapse,
  Modal,
  Typography,
} from "antd";
import { Dropdown, Menu } from "antd";
import jsPDF from 'jspdf';
import {
  DownloadOutlined,
  EditOutlined,
  InboxOutlined,
  FolderViewOutlined,
  MoreOutlined,
  PlusCircleOutlined,
  InfoCircleFilled,
} from "@ant-design/icons";
import axios from "axios";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import {
  DeleteOutlined,
  MinusCircleTwoTone,
  PlusCircleTwoTone,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import ProductApi from "../../common/Apis/ProductApi";
import AddProduct from "../../common/Models/AddProduct/AddProduct";
import EditProduct from "../../common/Models/AddProduct/EditProduct";
import ViewProduct from "../../common/Models/AddProduct/ViewProduct";
import IngredientsApi from "../../common/Apis/IngredientsApi";
import SuppliersApi from "../../common/Apis/SuppliersApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const Product = () => {
  const { Title } = Typography;
  let navigate = useNavigate();
  const FormData = require("form-data");
  const [formAdd] = Form.useForm();
  const [formadd2] = Form.useForm();

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [FilterEnable, setFilterEnable] = useState(true);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [formPaginate] = Form.useForm();
  
  const [shelfLifeModalVisible, setShelfLifeModalVisible] = useState(false);
  const [viewShelfLifeModalVisible, setViewShelfLifeModalVisible] = useState(false);
  const [selectedProduction, setSelectedProduction] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [totalElements, setTotalElements] = useState(0);

  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });

   const removeDuplicates = (products) => {
        const uniqueIds = new Set();
        return products.filter(product => {
          if (uniqueIds.has(product.id)) {
            return false;
          } else {
            uniqueIds.add(product.id);
            return true;
          }
        });
      }

  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    if (FilterEnable) {
      ProductApi.Listproducts(0, value)
        .then((response) => {
          settotalPages(response.totalPages);
          setProducts(response.payloadDto);
          setTotalElements(response.totalElements);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      let singleLineString = filterProducts
        .map((obj) => {
          if (obj.answerType === "%") {
            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
          } else if (obj.answerType === "=") {
            return `${obj.title}${obj.answerType}${obj.name}`;
          } else {
            return `${obj.title}=BETWEEN${createDateTimestamp(
              obj.answerType
            )}AND${createDateTimestamp(obj.name)}`;
          }
        })
        .join("&");

        // ADD subTenantId filter
    const subTenantFilter = `subTenant.id=${decodedToken?.subTenantId}`;
    const combinedFilter = singleLineString 
      ? `${singleLineString}&${subTenantFilter}`
      : subTenantFilter;
      
      let titles = filterProducts.map((obj) => obj.title);
      console.log(titles);
      let supplierName = 'supplier.supplierName';
      if (titles != supplierName) {
        let filderData = window.btoa("componentCode=PRODUCT&" + combinedFilter);
        QuestionnairesApi.FilterQuestionsetNext(filderData, 0, value)
          .then((response) => {
            settotalPages(response.totalPages);
            const uniqueProducts = removeDuplicates(response.payloadDto);
            setProducts(uniqueProducts);
            setTotalElements(response.totalElements);

          })
          .catch((err) => { });
      }
      else {
        let filderData = window.btoa("componentCode=PRODUCT&productToSuppliers." + combinedFilter);
        QuestionnairesApi.FilterQuestionsetNext(filderData, 0, value)
          .then((response) => {
            setCurrentPage(1);
            settotalPages(response.totalPages);
            const uniqueProducts = removeDuplicates(response.payloadDto);
            setProducts(uniqueProducts);
            setTotalElements(response.totalElements);
          })
          .catch((err) => { });

      }
    };
  }
  const handleOpenShelfLifeAnalysis = (product) => {
    setSelectedProduction(product?.productionDTO);
    setSelectedProduct(product);
    setShelfLifeModalVisible(true);
  };

  const handleOpenViewShelfLifeAnalysis = (product) => {
    setSelectedProduction(product?.productionDTO);
    setSelectedProduct(product);
    setViewShelfLifeModalVisible(true);
  };

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1


    if (FilterEnable) {
      ProductApi.Listproducts(pageNew, PaginateLimit)
        .then((response) => {
          setPaginatePage(pageNew)
          settotalPages(response.totalPages);
          setProducts(response.payloadDto);
          setTotalElements(response.totalElements);
        })
        .catch((err) => {
          console.log(err);
        });

    } else {

      let singleLineString = filterProducts
        .map((obj) => {
          if (obj.answerType === "%") {
            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
          } else if (obj.answerType === "=") {
            return `${obj.title}${obj.answerType}${obj.name}`;
          } else {
            return `${obj.title}=BETWEEN${createDateTimestamp(
              obj.answerType
            )}AND${createDateTimestamp(obj.name)}`;
          }
        })
        .join("&");

         // ADD subTenantId filter
    const subTenantFilter = `subTenant.id=${decodedToken?.subTenantId}`;
    const combinedFilter = singleLineString 
      ? `${singleLineString}&${subTenantFilter}`
      : subTenantFilter;

      let titles = filterProducts.map((obj) => obj.title);
      console.log(titles);
      let supplierName = 'supplier.supplierName';
      if (titles != supplierName) {
        let filderData = window.btoa("componentCode=PRODUCT&" + combinedFilter);
        QuestionnairesApi.FilterQuestionsetNext(filderData, pageNew, PaginateLimit)
          .then((response) => {
            setPaginatePage(pageNew)
            settotalPages(response.totalPages);
            const uniqueProducts = removeDuplicates(response.payloadDto);
            setProducts(uniqueProducts);
            setTotalElements(response.totalElements);
          })
          .catch((err) => { });
      }
      else {
        let filderData = window.btoa("componentCode=PRODUCT&productToSuppliers." + combinedFilter);
        console.log(filderData);
        QuestionnairesApi.FilterQuestionsetNext(filderData, pageNew, PaginateLimit)
          .then((response) => {
            setCurrentPage(1);
            settotalPages(response.totalPages);
            const uniqueProducts = removeDuplicates(response.payloadDto);
            setProducts(uniqueProducts);
            setTotalElements(response.totalElements);
          })
          .catch((err) => { });

      }
    };
  }
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
  } = useForm();

  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Products, setProducts] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const getProduct = useCallback(() => {
    ProductApi.Listproducts(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setProducts(response.payloadDto);
        setTotalElements(response.totalElements);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);


  useEffect(() => {
    getProduct();
    PageLoading();
    fetchFilterSupplier();
  }, [getProduct, PageLoading]);

  const handleDeleteProducts = (ProductID) => {
    ProductApi.DeleteProduct(ProductID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getProduct();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };


  const handleRemovefilterProducts = (FilterProductsIndex) => {
    const newfilterProduct = [...filterProducts];
    newfilterProduct.splice(FilterProductsIndex, 1);
    setFilterProducts(newfilterProduct);
    if (FilterProductsIndex == 0) {
      getProduct();
    }
  };
  const handleClear = () => {
    getProduct();
    setFilterEnable(true);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterProducts([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterProducts, setFilterProducts] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterProducts = () => {
    setFilterProducts([
      ...filterProducts,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handlePrintButtonClick2 = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [297, 210],
    });

    const fontSize = 12;


    let yPos = 35;
    doc.setFontSize(fontSize);

    const currentDate = new Date().toLocaleDateString();
    const currentTime = new Date().toLocaleTimeString();
    const promises = [];

    for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
      if (FilterEnable) {
        promises.push(
          ProductApi.Listproducts(i, PaginateLimit).then((response) => {
            doc.setFont('Poppins', 'bold');
            doc.text(`Product Master Sheet`, 150, 10, { align: 'center' });
            doc.setFont('Poppins', 'normal');
            doc.setFontSize(10);
            doc.text(`Date : ${currentDate}`, 10, 20);
            doc.text(`Time : ${currentTime}`, 10, 25);
            doc.setFontSize(fontSize);

            // Draw table headers and borders
            doc.setFont('Poppins', 'bold');
            doc.text('Date', 15, yPos);
            doc.text('Product Barcode', 45, yPos);
            doc.text('Product Name', 85, yPos);
            doc.text('Qty(UOM1)', 135, yPos);
            doc.text('Qty(UOM2)', 175, yPos);
            doc.text('Cost (UOM1)', 220, yPos);
            doc.text('Cost (UOM2)', 260, yPos);
            doc.setFont('Poppins', 'normal');
            doc.setLineWidth(0.1);
            doc.rect(12, yPos - 5, 280, 10);
            yPos += 10;

            response.payloadDto.forEach(row => {
              const date = formatDate(row?.productCreateDate);
              const productCode = row?.productCode;
              const productName = row?.productName;
              const qty1 = row?.unitOfMeasurement1 + ' ' + row?.unitUomOne;
              const qty2 = row?.unitOfMeasurement2 + ' ' + row?.unitUomTwo;
              const cost = row?.currency + ' ' + row?.costPriceUoM1;
              const allergenInfo = row?.currency + ' ' + row?.costPriceUoM2;

              doc.setFontSize(fontSize);

              doc.text(date, 15, yPos);
              doc.text(productCode, 45, yPos);
              doc.text(productName, 85, yPos);
              doc.text(qty1, 135, yPos);
              doc.text(qty2, 175, yPos);
              doc.text(cost, 220, yPos);
              const allergenLines = doc.splitTextToSize(allergenInfo, 40);
              doc.text(allergenLines, 260, yPos);

              const rowHeight = 10 * Math.max(allergenLines.length, 1);

              if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                doc.addPage();
                yPos = 35; // Reset yPos for the new page
              } else {
                doc.setLineWidth(0.1);
                doc.rect(12, yPos - 5, 280, rowHeight);
                yPos += rowHeight;
              }
            });

            if (i === parseInt(PaginatetotalPages)) {
              doc.addPage();
              yPos = 35;
            }
          }).catch((err) => {
            console.log(err);
          })
        );
      } else {
        let singleLineString = filterProducts
          .map((obj) => {
            if (obj.answerType === "%") {
              return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
            } else if (obj.answerType === "=") {
              return `${obj.title}${obj.answerType}${obj.name}`;
            } else {
              return `${obj.title}=BETWEEN${createDateTimestamp(
                obj.answerType
              )}AND${createDateTimestamp(obj.name)}`;
            }
          })
          .join("&");

        let titles = filterProducts.map((obj) => obj.title);
        console.log(titles);
        let supplierName = 'supplier.supplierName';
        if (titles != supplierName) {
          var filderData1 = window.btoa("componentCode=PRODUCT&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
        }
        else {
          var filderData1 = window.btoa("componentCode=PRODUCT&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
        }

        promises.push(
          QuestionnairesApi.FilterQuestionsetNext(filderData1, i, PaginateLimit).then((response) => {
            doc.setFont('Poppins', 'bold');
            doc.text(`Product Master Sheet`, 150, 10, { align: 'center' });
            doc.setFont('Poppins', 'normal');
            doc.setFontSize(10);
            doc.text(`Date : ${currentDate}`, 10, 20);
            doc.text(`Time : ${currentTime}`, 10, 25);
            doc.setFontSize(fontSize);

            // Draw table headers and borders
            doc.setFont('Poppins', 'bold');
            doc.text('Date', 15, yPos);
            doc.text('Product Barcode', 45, yPos);
            doc.text('Product Name', 85, yPos);
            doc.text('Qty(UOM1)', 135, yPos);
            doc.text('Qty(UOM2)', 175, yPos);
            doc.text('Cost (UOM1)', 220, yPos);
            doc.text('Cost (UOM2)', 260, yPos);
            doc.setFont('Poppins', 'normal');
            doc.setLineWidth(0.1);
            doc.rect(12, yPos - 5, 280, 10);
            yPos += 10;

            response.payloadDto.forEach(row => {
              const date = formatDate(row?.productCreateDate);
              const productCode = row?.productCode;
              const productName = row?.productName;
              const qty1 = row?.unitOfMeasurement1 + ' ' + row?.unitUomOne;
              const qty2 = row?.unitOfMeasurement2 + ' ' + row?.unitUomTwo;
              const cost = row?.currency + ' ' + row?.costPriceUoM1;
              const allergenInfo = row?.currency + ' ' + row?.costPriceUoM2;

              doc.setFontSize(fontSize);

              doc.text(date, 15, yPos);
              doc.text(productCode, 45, yPos);
              doc.text(productName, 85, yPos);
              doc.text(qty1, 135, yPos);
              doc.text(qty2, 175, yPos);
              doc.text(cost, 220, yPos);
              const allergenLines = doc.splitTextToSize(allergenInfo, 40);
              doc.text(allergenLines, 260, yPos);

              const rowHeight = 10 * Math.max(allergenLines.length, 1);

              if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                doc.addPage();
                yPos = 35; // Reset yPos for the new page
              } else {
                doc.setLineWidth(0.1);
                doc.rect(12, yPos - 5, 280, rowHeight);
                yPos += rowHeight;
              }
            });

            if (i === parseInt(PaginatetotalPages)) {
              doc.addPage();
              yPos = 35;
            }
          }).catch((err) => {
            console.log(err);
          })
        );
      }


    }

    const reversedPromises = promises.map(promise =>
      promise.then(result =>
        new Promise(resolve =>
          setTimeout(() => resolve(result), 0)
        )
      )
    );

    Promise.all(reversedPromises)
      .then(() => {
        window.open(doc.output('bloburl'), '_blank');
      })
      .catch((err) => {
        console.log(err);
      });

  };






  const onSubmit = (data) => {
    const token = localStorage.getItem("UserjwtToken");
    const formData = new FormData();
    formData.append("file", ImportFile);
    formData.append("tenantId", decodedToken?.tenantId);
    formData.append("tenantDTO", {
      id: decodedToken?.tenantId,
      tenantApiKey: decodedToken?.tenantApiKey,
    });
    let url = `http://iva-api-dev-681889668.eu-west-1.elb.amazonaws.com:8080/api/v1/data-process/products`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    axios
      .post(url, formData, {
        headers: headers,
      })
      .then((res) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Upload</span>,
          description: "Upload Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((err) => {
        console.log(err);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Error</span>,
          description: err?.response?.data?.apiError?.message,
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#fff2f0",
            color: "red",
          },
        });
      });
  };
  const handleSubmitFilter = (data) => {
    console.log(data);
    setFilterEnable(false);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    console.log(filterProducts);
    let singleLineString = filterProducts
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=BETWEEN${createDateTimestamp(
            obj.answerType
          )}AND${createDateTimestamp(obj.name)}`;
        }
      })
      .join("&");

      // ADD subTenantId filter
  const subTenantFilter = `subTenant.id=${decodedToken?.subTenantId}`;
  const combinedFilter = singleLineString 
    ? `${singleLineString}&${subTenantFilter}`
    : subTenantFilter;

    console.log(singleLineString);
    let titles = filterProducts.map((obj) => obj.title);
    console.log(titles);
    let supplierName = 'supplier.supplierName';
    if (!titles.includes(supplierName)) {
      let filderData = window.btoa("componentCode=PRODUCT&" + combinedFilter);
      console.log(filderData);
      QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
        .then((response) => {
          setCurrentPage(1);
          settotalPages(response.totalPages);
          const uniqueProducts = removeDuplicates(response.payloadDto);
          setProducts(uniqueProducts);
          setTotalElements(response.totalElements);
          // setProducts(response.payloadDto);
        })
        .catch((err) => { });

    }
    else {
      let filderData = window.btoa("componentCode=PRODUCT&productToSuppliers." + combinedFilter);
      console.log(filderData);
      QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
        .then((response) => {
          setCurrentPage(1);
          settotalPages(response.totalPages);
          const uniqueProducts = removeDuplicates(response.payloadDto);
          setProducts(uniqueProducts);
          setTotalElements(response.totalElements);
          // setProducts(response.payloadDto);
        })
        .catch((err) => { });

      let x = window.atob(filderData);
      console.log(x);
    }


    //     let y = "id=2";
    //     let filderData1 = window.btoa("componentCode=PRODUCT&" + y);

    // console.log(filderData1);



  };
  const createDateTimestamp = (Cdate) => {
    const timestamp = new Date(Cdate).getTime();
    return timestamp;
  };


  const handleChangeTitle = (filterDesignationIndex, value) => {
    const newfilterProduct = [...filterProducts];
    newfilterProduct[filterDesignationIndex].title = value;
    setFilterProducts(newfilterProduct);
    const fieldName = 'name' + filterDesignationIndex;
    const fieldName2 = 'nameto' + filterDesignationIndex;
    formadd2.setFieldsValue({
      [fieldName]: null,
      [fieldName2]: null,
    });
  };
  const handleChangeAnswertypeFilter = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterProducts];

    newfilterProduction[FiltergetproductionIndex].answerType = '=';
    newfilterProduction[FiltergetproductionIndex].name = value;
    setFilterProducts(newfilterProduction);
  };

  const handleChangeAnswertype = (filterDesignationIndex, value) => {
    const newfilterProduct = [...filterProducts];
    newfilterProduct[filterDesignationIndex].answerType = value;
    setFilterProducts(newfilterProduct);
  };

  const handleChangename = (filterDesignationIndex, value) => {
    const newfilterProduct = [...filterProducts];
    newfilterProduct[filterDesignationIndex].name = value;
    setFilterProducts(newfilterProduct);
  };

  const handleDelete = () => {
    // Handle delete action
    console.log("Delete clicked");
  };


  const paginatedData = Products;

  const validateFileType = (file) => {
    const allowedExtensions = [".xls", ".xlsx"];
    const fileExtension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      message.error("Invalid file format. Allowed formats: Excel (xls, xlsx).");
      return false;
    }
    return true;
  };
  const [ImportFile, setImportFile] = useState(null);
  const [isDisable, setIsDisable] = useState(true);
  const handleFileChange = (event) => {
    const file = event.target.files[0];


    if (file) {
      setIsDisable(false);
      setImportFile(file);
    } else {
      setIsDisable(true);
    }
    // Your file handling logic here
  };
  function formatDate(date) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options);

    const [month, day, year] = formattedDate.split(" ");

    const capitalizedMonth = month.toUpperCase();

    return `${day} ${capitalizedMonth} ${year}`;
  }
  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td style={{ width: "17%" }} className="pt-3">
            {item?.productCreateDate ? formatDate(item?.productCreateDate) : ""}
          </td>
          <td style={{ width: "18%" }} className="pt-3">
            {item?.productCode?.split('#')?.[1]} 
          </td>
          <td style={{ width: "18%" }} className="pt-3">
            {item?.productName}
          </td>
          <td style={{ width: "12%" }} className="pt-3">
            {item?.supplierDTO?.map(item => item?.supplierName)?.join(' , ')}
          </td>
          <td style={{ width: "10%", textAlign: 'end' }} className="pt-3">
            {item?.unitOfMeasurement1}&nbsp;{item?.unitUomOne}
          </td>
          <td style={{ width: "8%", textAlign: 'end' }} className="pt-3">
            {item?.unitOfMeasurement2}&nbsp;{item?.unitUomTwo}
          </td>
          <td style={{ width: "8%", textAlign: 'end' }} className="pt-3">
            {item?.currency} {item?.costPriceUoM1}
          </td>
          <td style={{ width: "12%", textAlign: 'end' }} className="pt-3">
            {item?.currency} {item?.costPriceUoM2}
          </td>
          <td style={{ width: "8%", textAlign: 'center' }} className="pt-3">

            {(item?.allergens.length > 0) ? (
              <Tooltip placement="top" title={(
                <div>
                  {item?.allergens?.map(allergen => (
                    <React.Fragment key={allergen.id}>
                      {allergen.allergensName}
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              )}>
                <InfoCircleFilled className="inforIcon" />
              </Tooltip>
            ) : null}

          </td>
          <td style={{ width: "25%" }}>
            <div className="d-flex justify-content-center">
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key="view"
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'VIEW_PRODUCT'
                      ) ? '' : 'd-none'}
                      onClick={() => handleOpenViewModal(item.productName, item.id)}
                    >
                      <FolderViewOutlined /> View
                    </Menu.Item>
                    <Menu.Item
                      key="edit"
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'EDIT_PRODUCT'
                      ) ? '' : 'd-none'}
                      onClick={() => handleOpenEditModal(item.id)}
                    >
                      <EditOutlined /> Edit
                    </Menu.Item>
                    <Menu.Item key="delete"
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'DELETE_PRODUCT'
                      ) ? '' : 'd-none'}
                      onClick={handleDelete}>
                      <Popconfirm
                        title="Are you sure ?"
                        description="Do you really want to delete this Product ?"
                        okText="Yes"
                        onConfirm={() => handleDeleteProducts(item.id)}
                        placement="topRight"
                        className="w-100"
                        cancelText="No"
                      >
                        <DeleteOutlined /> Delete
                      </Popconfirm>
                    </Menu.Item>
                     <Menu.Item
                      key="shelfAnalysis"
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'EDIT_PRODUCT'
                      ) ? '' : 'd-none'}
                      onClick={() => handleOpenShelfLifeAnalysis(item)}
                    >
                      <FaChartBar /> Shelf Analysis
                    </Menu.Item>
                    <Menu.Item
                      key="viewShelfAnalysis"
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'VIEW_PRODUCT'
                      ) ? '' : 'd-none'}
                      onClick={() => handleOpenViewShelfLifeAnalysis(item)}
                    >
                      <IoMdEye /> View Shelf Analysis
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <div className="action-circle">
                  <MoreOutlined />
                </div>
              </Dropdown>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={10} className="text-center ">
            <EmptyBox />
            <br />
            <Button
              type="primary"
              onClick={handleOpenAddModal}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_PRODUCT'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add Product
            </Button>
          </td>
        </tr>
      );
    }
  };


  const [isModalproduct, setIsModalProduct] = useState(false);

  const showModal = () => {
    setIsModalProduct(true);
  };
  const handleOk = () => {
    setIsModalProduct(false);
  };
  const handleCancelProduct = () => {
    setIsModalProduct(false);
    formAdd.resetFields();
    setIsDisable(true);
  };
  const [modalAddVisible, setModalAddVisible] = useState(false);

  const handleOpenAddModal = () => {
    setModalAddVisible(true);
    setIsModalProduct(false);
  };
  const handleAddCloseModal = () => {
    setModalAddVisible(false);
  };

  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");
  const [Ingredients, setIngredients] = useState("");

  const handleOpenEditModal = (ProductID) => {
    ProductApi.SingleProducts(ProductID)
      .then((response) => {
        setModalEditData(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
    IngredientsApi.SingleProducts(ProductID)
      .then((response) => {
        setIngredients(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });

    setModalEditVisible(true);
  };
  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
  };

  const [modalViewVisible, setModalViewVisible] = useState(false);
  const [modalViewData, setModalViewData] = useState("");

  const handleOpenViewModal = (ProductName, ProductID) => {
    return navigate('/product/' + ProductName.replace(/\s+/g, '-') + `?id=${ProductID}`);
    // ProductApi.SingleProducts(ProductID)
    //   .then((response) => {
    //     setModalViewData(response.payload);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // setModalViewVisible(true);
  };
  const handlViewCloseModal = () => {
    setModalViewVisible(false);
  };
  const exportToCsv = async () => {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Products');

    const customHeaders = [
      'productDate',
      'productName',
      'unitOfMeasurement1',
      'unitOfMeasurement2',
      'costPriceUoM1',
      'costPriceUoM2',
      'costPriceUoM1',
      'sellingPriceUoM2',
      'department',
      'openUBD',
      'allergens',
      'supplier',
    ];

    worksheet.addRow(customHeaders);

    Products.forEach((item) => {
      worksheet.addRow([
        formatCSV(item?.productCreateDate),
        item?.productName,
        item?.unitOfMeasurement1,
        item?.unitOfMeasurement2,
        item?.costPriceUoM1,
        item?.costPriceUoM2,
        item?.sellingPriceUoM1,
        item?.sellingPriceUoM2,
        item?.department,
        item?.openUBD,
        item?.allergens,
        item?.supplierName,
      ]);
    });

    worksheet.getColumn(1).width = 20;
    worksheet.getRow(1).font = { bold: true };

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveAs(blob, 'Product.xlsx');
  };

  function formatCSV(productCreateDate) {
    const date = new Date(productCreateDate);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  const [FilterSuppliers, setFilterSuppliers] = useState([]);
  const [TotalPageNew, setTotalPageNew] = useState(null);
  const [page, setPage] = useState(0);


  const fetchFilterSupplier = async () => {
    try {
      SuppliersApi.Listsuppliers(page, 10)
        .then((response) => {
          // setDepartments(response?.payloadDto);
          setTotalPageNew(response.totalPages);
          setFilterSuppliers(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

          setPage(prevPage => prevPage + 1);

        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
    } finally {
    }
  };
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
    if (bottom || nearBottom) {
      if (TotalPageNew > page) {
        fetchFilterSupplier();
      }
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader onPrintResponse2={handlePrintButtonClick2} />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            form={formadd2}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmitFilter}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterProducts.map((input, filterProductsIndex) => (
                    <div key={filterProductsIndex}>
                      <Row gutter={12} className="pt-2">
                        <Col lg={5} md={5} className="px-1">
                          <Form.Item
                            name={`title${filterProductsIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterProductsIndex, value)
                              }
                              options={[
                                { value: "productName", label: "Product Name" },
                                { value: "productCode", label: "Product barcode" },
                                { value: "productCreateDate", label: "Date" },
                                { value: "supplier.supplierName", label: "Supplier" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        {filterProducts[filterProductsIndex].title ==
                          "productCreateDate" ? (
                          <>
                            <Col lg={4} md={4} className="px-1">
                              <Form.Item
                                name={`nameto${filterProductsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  placeholder="Filter By"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterProductsIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </>
                        ) : filterProducts[filterProductsIndex].title === "supplier.supplierName" ? (
                          <>
                            <Col lg={6} md={6} className="px-1">
                              <Form.Item
                                name={`nameto${filterProductsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  className="control-Select mb-1"
                                  placeholder="Select Supplier"
                                  onPopupScroll={handleScroll}
                                  onChange={(value) =>
                                    handleChangeAnswertypeFilter(
                                      filterProductsIndex,
                                      value
                                    )
                                  }
                                  filterOption={(input, option) =>
                                    (option.props.children && option.props.children.toString().toLowerCase().includes(input.toLowerCase())) ||
                                    (option.props.children && option.props.children.toString().toLowerCase().includes(input.toLowerCase()))
                                  }
                                >
                                  {FilterSuppliers.map((option, index) => (
                                    <Select.Option key={option.id} value={option.supplierName}>
                                      {option.supplierName} ( {option.institutionDTO?.institutionName})
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col lg={4} md={4} className="px-1">
                              <Form.Item
                                name={`type${filterProductsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterProductsIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                        {filterProducts[filterProductsIndex].title ==
                          "productCreateDate" ? (
                          <>
                            <Col lg={5} md={5} className="px-1">
                              <Form.Item
                                name={`name${filterProductsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterProductsIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </>
                        ) : filterProducts[filterProductsIndex].title === "supplier.supplierName" ? (
                          <>

                          </>
                        ) : (
                          <>
                            <Col lg={5} md={5} className="px-1">
                              <Form.Item
                                name={`name${filterProductsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterProductsIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                        <Col lg={8} md={10} className="px-1">
                          <Form.Item className="text-lable">
                            {filterProductsIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterProducts}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterProducts(
                                      filterProductsIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div
                style={{
                  display: "flex",
                  gap: "12px", // spacing between buttons
                  alignItems: "center",
                }}
              >
                {paginatedData?.length > 0 && <Button
                  type="primary"
                  style={{
                    display: decodedToken?.permissions?.some(
                      (permission) => permission?.authority === "ADD_PRODUCT"
                    )
                      ? "block"
                      : "none",
                    height: "auto",
                    lineHeight: "normal",
                    alignItems: "center",
                    padding: "5px 24px",
                  }}
                  onClick={handleOpenAddModal}
                >
                  Add Product
                </Button>}

                <Link to={"/stock-list"}>
                  <Button
                    type="primary"
                    style={{
                      display: decodedToken?.permissions?.some(
                        (permission) => permission?.authority === "ADD_PRODUCT"
                      )
                        ? "block"
                        : "none",
                      height: "auto",
                      lineHeight: "normal",
                      alignItems: "center",
                      padding: "5px 24px",
                    }}
                  >
                    See Stock
                  </Button>
                </Link>
              </div>

              {/* <div>
                {paginatedData?.length > 0 && (
                  // <Button
                  //   className={decodedToken?.permissions?.some(
                  //     (permission) => permission?.authority === 'ADD_PRODUCT'
                  //   ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
                  //   onClick={handleOpenAddModal}
                  // >
                  //   Add Product
                  // </Button>
                  <Button
                    type="primary"
                    style={{
                      display: decodedToken?.permissions?.some(
                        permission => permission?.authority === 'ADD_PRODUCT'
                      ) ? 'block' : 'none',
                      height: 'auto',
                      lineHeight: 'normal',
                      alignItems: 'center',
                      padding: '5px 24px',
                    }}
                    onClick={handleOpenAddModal}
                  >
                    Add Product
                  </Button>
                )}
                <Link to={'/stock-list'}>
                  <Button
                    type="primary"
                    style={{
                      display: decodedToken?.permissions?.some(
                        permission => permission?.authority === 'ADD_PRODUCT'
                      ) ? 'flex' : 'none',
                      height: 'auto',
                      lineHeight: 'normal',
                      alignItems: 'center',
                      padding: '5px 24px',
                    }}
                  >
                    See Stock
                  </Button>
                </Link>
              </div> */}
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Product Barcode</th>
                  <th>Product Name</th>
                  <th>Supplier</th>
                  <th className="text-end">Qty(UOM1)</th>
                  <th className="text-end">Qty(UOM2)</th>
                  <th className="text-end">Cost (UOM1)</th>
                  <th className="text-end">Cost (UOM2)</th>
                  <th className="text-end">Allergens</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}  // Use the API response totalPages
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>
        <Modal
          open={isModalproduct}
          onOk={handleOk}
          onCancel={handleCancelProduct}
          footer={[]}
        >
          <Form form={formAdd} onFinish={handleSubmit(onSubmit)}>
            <div className="product-model text-center">
              <Title level={4} className="Primary-Font ">
                Add Product
              </Title>
              <br />
              <Form.Item
                name="file"
                className="text-lable"
                style={{ visibility: "hidden", display: "none" }}
              >
                <Input
                  type="file"
                  id="fileInput"
                  onChange={handleFileChange}
                  className="control-input"
                  accept=".xls, .xlsx"
                />
              </Form.Item>
              <label htmlFor="fileInput">
                <InboxOutlined className="pb-3" />
                <p style={{ color: "#3E55A4", cursor: "pointer" }}>
                  Import File
                </p>
                {errors.uploadFile && (
                  <p style={{ color: "red" }}>Please Import File.</p>
                )}
              </label>
              <p
                className={`${isDisable ? "d-none" : "pb-0 mb-0"}`}
                style={{ color: "green" }}
              >
                File is selected
              </p>
              <br />
              <DownloadOutlined onClick={exportToCsv} className="pb-3" />
              <br />
              <a href="#" onClick={exportToCsv}>
                Download CSV File
              </a>
              <br />
              <PlusCircleOutlined
                onClick={handleOpenAddModal}
                className="py-3"
              />
              <br />
              <a href="#" onClick={handleOpenAddModal}>
                Or Use this link for individual product
              </a>
            </div>
            <div className="d-flex justify-content-center pt-4">
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: "37%",
                  height: "10%",
                  lineHeight: "normal",
                  alignItems: "center",
                  padding: "5px 24px",
                  margin: "0 8px"
                }}
                disabled={isDisable}
              >
                Submit
              </Button>

              <Button
                type="default"
                style={{
                  width: "37%",
                  height: "auto",
                  lineHeight: "normal",
                  alignItems: "center",
                  padding: "5px 24px",
                  margin: "0 8px"
                }}
                onClick={handleCancelProduct}
              >
                Cancel
              </Button>
            </div>{" "}
          </Form>
        </Modal>
        {modalAddVisible && <AddProduct visible={modalAddVisible} onClose={handleAddCloseModal} />}
        {modalEditVisible && <EditProduct
          visible={modalEditVisible}
          onClose={handlEditeCloseModal}
          Product={modalEditData}
          Ingredient={Ingredients}
        />}
        <ViewProduct
          visible={modalViewVisible}
          onClose={handlViewCloseModal}
          Product={modalViewData}
        />
        {shelfLifeModalVisible && (
          <ShelfLifeAnalysis
            visible={shelfLifeModalVisible}
            onClose={() => setShelfLifeModalVisible(false)}
            afterCookId={selectedProduction}
            Production={selectedProduct}
          />
        )}
        {viewShelfLifeModalVisible && (
          <ShelfLifeData
            visible={viewShelfLifeModalVisible}
            onClose={() => setViewShelfLifeModalVisible(false)}
            Productctionid={selectedProduct?.id}
            source="product" 
          />
        )}
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Product;